// src/pages/privacy/PrivacyPolicyPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { pagesApi } from "../../api/pagesApi";

const defaultText = `
Privacy Policy

We respect your privacy. This page explains how information is handled on this business page.

Information we may collect:
- Contact form details (if a form exists on this page)
- Basic analytics (if enabled by the site owner)

How we use information:
- To respond to requests
- To improve the website experience

Sharing:
- We do not sell personal information.

Contact:
If you have questions about privacy, contact the business using the details on the website.
`.trim();

export default function PrivacyPolicyPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);

  useEffect(() => {
    let ignore = false;

    async function load() {
      if (!slug) return;
      try {
        const p = await pagesApi.getBySlug(slug);
        if (!ignore) setPage(p);
      } catch {
        if (!ignore) setPage(null);
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, [slug]);

  const businessName = page?.footer?.config?.businessName || page?.name || "Business";

  const text = useMemo(() => {
    const custom = page?.footer?.config?.privacyPolicyContent;
    return String(custom || defaultText).trim();
  }, [page]);

  const paragraphs = useMemo(() => {
    return text.split("\n\n").map((p) => p.trim()).filter(Boolean);
  }, [text]);

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="max-w-3xl mx-auto">
        <div className="mb-6 flex items-center justify-between gap-3">
          <div>
            <div className="text-2xl font-bold text-gray-900">Privacy Policy</div>
            <div className="text-sm text-gray-600">{businessName}</div>
          </div>

          {slug ? (
            <Link to={`/${slug}`} className="px-4 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm">
              Back to page
            </Link>
          ) : (
            <Link to="/" className="px-4 py-2 rounded-lg border bg-white hover:bg-gray-50 text-sm">
              Home
            </Link>
          )}
        </div>

        <div className="bg-white rounded-2xl border shadow-sm p-6 space-y-4">
          {paragraphs.map((p, i) => (
            <p key={i} className="text-gray-700 leading-relaxed">
              {p}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
